module.exports = __webpack_public_path__ + "static/media/3.c69e02b0.mp3";